import { useMemo, useState } from "react";
import { hotItems } from "@/mocks/gossip";
import Reveal from "./Reveal";

const tabs = [
  { key: "全部", label: "全部热瓜" },
  { key: "娱乐圈", label: "娱乐圈" },
  { key: "网络热点", label: "网络热点" },
  { key: "商业圈", label: "商业圈" },
  { key: "社会议题", label: "社会议题" },
];

export default function HotList() {
  const [activeTab, setActiveTab] = useState("全部");
  const [expand, setExpand] = useState(false);

  const list = useMemo(
    () => (activeTab === "全部" ? hotItems : hotItems.filter((h) => h.cat === activeTab)),
    [activeTab]
  );
  const visible = expand ? list : list.slice(0, 4);

  const trendIcon = (trend: string) =>
    trend === "up" ? (
      <i className="ri-arrow-up-line text-sm text-primary-600"></i>
    ) : trend === "down" ? (
      <i className="ri-arrow-down-line text-sm text-secondary-500"></i>
    ) : (
      <i className="ri-arrow-right-line text-sm text-foreground-400"></i>
    );

  const fmtHeat = (n: number) => (n >= 10000 ? `${(n / 10000).toFixed(1)}万` : String(n));

  return (
    <section id="hot" className="bg-background-100 py-16 md:py-24">
      <div className="section-wrap">
        <Reveal>
          <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="flex items-center gap-2 text-sm font-medium text-primary-700">
                <span className="h-px w-6 bg-primary-600"></span> TRENDING NOW
              </p>
              <h2 className="font-serif-editorial mt-3 text-3xl font-black text-foreground-950 md:text-4xl">
                今日热瓜
              </h2>
              <p className="mt-3 text-foreground-600">实时热度榜单 · 正在发生的八卦都在这</p>
            </div>
          </div>
        </Reveal>

        {/* tabs */}
        <Reveal delay={60}>
          <div className="mt-8 flex flex-wrap gap-2">
            {tabs.map((t) => (
              <button
                key={t.key}
                onClick={() => {
                  setActiveTab(t.key);
                  setExpand(false);
                }}
                className={`whitespace-nowrap rounded-full px-5 py-2 text-sm transition-colors ${
                  activeTab === t.key
                    ? "bg-primary-600 font-medium text-white"
                    : "bg-background-50 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </Reveal>

        {/* list */}
        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {visible.map((h, idx) => (
            <Reveal key={h.id} delay={idx * 40}>
              <article className="group flex gap-5 rounded-2xl border border-background-200 bg-background-50 p-5 transition-shadow hover:shadow-lg">
                <div className="flex flex-col items-center gap-2 pt-1">
                  <span
                    className={`flex h-10 w-10 items-center justify-center rounded-xl font-serif-editorial text-lg font-black ${
                      idx < 3
                        ? "bg-primary-600 text-white"
                        : "bg-accent-100 text-accent-800"
                    }`}
                  >
                    {h.rank}
                  </span>
                  <span className="flex h-5 items-center">{trendIcon(h.trend)}</span>
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-800">
                      {h.cat}
                    </span>
                    <span className="text-xs text-foreground-500">{h.tag}</span>
                    <span className="ml-auto text-xs text-foreground-400">{h.update}</span>
                  </div>
                  <h3 className="mt-2 text-[17px] font-bold leading-snug text-foreground-900 group-hover:text-primary-700">
                    {h.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">
                    {h.summary}
                  </p>
                  <div className="mt-3 flex items-center gap-1.5 text-xs font-medium text-primary-700">
                    <i className="ri-fire-fill text-accent-600"></i>
                    热度 {fmtHeat(h.heat)}
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        {list.length > 4 && (
          <div className="mt-8 text-center">
            <button
              onClick={() => setExpand((v) => !v)}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              {expand ? "收起榜单" : "展开完整榜单"}
              <i className={expand ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}